export default "__VITE_ASSET__CR2PiZXn__"